
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lp/[landingPageSlug]",
      function () {
        return require("private-next-pages/lp/[landingPageSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lp/[landingPageSlug]"])
      });
    }
  